module.exports = __webpack_public_path__ + "static/img/planRight3.af18ba65.png";